import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import { debounce } from 'lodash'

const checkStatus = res => {
  if (res?.status >= 200 && res.status < 300) {
    if (res.data?.code === 200) {
      return res
    }
  }
  if (res?.data?.code === 403) {
    sessionStorage.clear()
    window.location.href = '/#/login'
  }
  throw res
}

const toast = debounce(err => {
  let msg = '异常错误'
  if (err.status === 404 || err.response?.status === 404) {
    msg = '找不到该请求'
  } else if (err.data) {
    msg = err.data.message || err.data.body || err.data.head?.result
  } else {
    msg = '请求失败'
  }
  Message.closeAll()
  Message.error(msg)
}, 300)

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} data      The options we want to pass to "fetch"
 * @param  {string} method    The type we want to request
 * @return {object}           An object containing either "data" or "err"
 */
const fetch = (url, data = {}, method = 'get') => {
  const baseUrl = process.env.NODE_ENV === 'production' ? '' : '/api/'
  url = baseUrl + url
  const headers = {}
  // 设置token
  const { token } = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
  if (token) {
    headers.token = `${token}`
  }


  if (method === 'get') {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: `${url}?${qs.stringify(data)}`,
        headers
      })
        .then(checkStatus)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          toast(err)
          reject(err)
        })
    })
  } if (method === 'post' || method === 'put') {
    if (!(data instanceof FormData)) {
      headers['Content-Type'] = 'application/json; charset=UTF-8'
      data = JSON.stringify(data)
    }

    return new Promise((resolve, reject) => {
      axios({
        method,
        url,
        data,
        headers
      })
        .then(checkStatus)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          toast(err)
          reject(err)
        })
    })
  } if (method === 'delete') {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `${url}/${data}`,
        headers
      })
        .then(checkStatus)
        .then(res => {
          resolve(res.data.data)
        })
        .catch(err => {
          toast(err)
          reject(err)
        })
    })
  }
}

export default fetch
